import { makeStyles, type Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  dialogTitle: {
    color: "#37474f",
    maxWidth: "80%",
    "& .MuiTypography-root": {
      color: "#37474f",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  paper: {
    minWidth: 487,
    maxWidth: 487,
  },
  helperText: {
    textAlign: "right",
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    color: "#828282",
  },
}));
